import { isEmpty } from 'ramda'
import { utils, components } from '@digital-commerce/shared-utils'
import { object } from 'prop-types'
import { useContext } from 'react'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import {
  FinalPrice,
  ItemsPrice,
  OtherChargesAndCreditsContainer
} from '../../molecules/CartItem/PriceBreakdown'
import { isAffiliateCampaign, getFirstMonthItemPrice } from '../../../utils/cart'
import PriceBreakdownContainer from '../../molecules/CartItem/PriceBreakdown/PriceBreakdownContainer'
import {
  buildRecurringDiscountList,
  buildFirstMonthPromotionsForFirstMonthPaymentOnlyItemList,
  buildDiscountsAndCreditsList
} from './utils'
import HeadingWithSubItems from '../../molecules/CartItem/PriceBreakdown/HeadingWithSubItems'
import NameAndPrice from '../../atoms/ItemDetails/NameAndPrice'

const {
  cart: { getMonthlyTotalPrice }
} = utils

const { ShouldRender } = components

const OfferDetails = ({ addon, cart }) => {
  const translate = useTranslate()
  const { lang } = useContext(localeContext)
  const isAffiliates = isAffiliateCampaign(cart)

  const { total: monthlyTotalPrice } = getMonthlyTotalPrice(addon) ?? {}
  const isFirstMonthPaymentOnly = !isEmpty(getFirstMonthItemPrice(addon))
  const recurringDiscountsData = buildRecurringDiscountList(addon, lang, translate, isAffiliates)
  const firstMonthPromotionsForItemWithFirstMonthPaymentOnlyData =
    buildFirstMonthPromotionsForFirstMonthPaymentOnlyItemList(addon, isFirstMonthPaymentOnly, lang)
  const discountsAndCreditsData = buildDiscountsAndCreditsList(addon, cart, lang)

  const dueMonthlyPrice = (
    <ShouldRender when={!isFirstMonthPaymentOnly}>
      <FinalPrice price={monthlyTotalPrice} isMonthly />
    </ShouldRender>
  )

  const recurringDiscounts = recurringDiscountsData?.map((discount) => (
    <NameAndPrice
      id={discount.id}
      key={discount.id}
      name={discount.name}
      price={discount.price}
      prefixIcon={discount.prefixIcon}
    />
  ))

  // These promotions (one-time discounts/promotions) apply when an addon price is being
  // charged on the customers first bill only (paid in full on first bill)
  const firstMonthPromotionsForItemWithFirstMonthPaymentOnly =
    firstMonthPromotionsForItemWithFirstMonthPaymentOnlyData?.map((promotion) => (
      <NameAndPrice
        id={promotion.id}
        key={promotion.id}
        name={promotion.name}
        price={promotion.price}
        prefixIcon={promotion.prefixIcon}
      />
    ))

  const discountsAndCredits = (
    <HeadingWithSubItems
      headingText={translate('additionalChargesAndCredits.additionalCreditsAndDiscounts')}
      subItems={discountsAndCreditsData}
    />
  )

  return (
    <>
      <PriceBreakdownContainer>
        <ItemsPrice
          items={[addon]}
          isRecurring={!isFirstMonthPaymentOnly}
          isFirstMonthPaymentOnly={isFirstMonthPaymentOnly}
        />
        {recurringDiscounts}
        {firstMonthPromotionsForItemWithFirstMonthPaymentOnly}
        {dueMonthlyPrice}
      </PriceBreakdownContainer>
      <OtherChargesAndCreditsContainer listData={discountsAndCreditsData}>
        {discountsAndCredits}
      </OtherChargesAndCreditsContainer>
    </>
  )
}

export default OfferDetails

OfferDetails.propTypes = {
  addon: object.isRequired,
  cart: object.isRequired
}
